/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface ServiceSubscriptionHistoryModel { 
    id: string;
    phonenumber?: string;
    subscribed: boolean;
    startDate: Date;
    subscriptionDate: Date;
    expiryDate: Date;
    serviceCode?: string;
    serviceId?: string;
    serviceName?: string;
    serviceProviderName?: string;
    dateCreated: Date;
    autoRenew: boolean;
}
